import './DeparturesFiltersTools.scss';

import FilterAltOff from "@mui/icons-material/FilterAltOff";

import { useApplyFilters } from "../../../../hooks/useApplyFilters";

import { TextButton } from "../../../../common-components/Buttons/Buttons";

const DeparturesFiltersTools = () => {
    const componentId = "departures";
    const { clearFiltersParams } = useApplyFilters({componentId});

    return (
        <div className={"departures-filters-tools"}>
            <div className={"departures-filters-tools_container"}>
                <TextButton Icon={FilterAltOff} title={"Сбросить фильтры"} onClick={clearFiltersParams} active={true} color={"#f44336"}/>
            </div>
        </div>
    )
}

export default DeparturesFiltersTools;